import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { Photo } from '../../shared/Photo';

export const FortuneHomeHintDialog: React.FC = () => {
  const { t } = useTranslation('fortune');

  return (
    <Dialog hasHeader={true}>
      <div
        className={css`
          color: #938666;
          text-align: center;
          h1 {
            color: #4d3906;
            font-size: 24px;
            margin-bottom: 32px;
          }
          p {
            margin: 0 0 16px;
          }
          section {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 12px 0;
          }
          section:last-child {
            padding-bottom: 40px;
          }
          .photo {
            width: 278px;
            height: 180px;
            margin: 12px auto 28px;
            position: relative;
          }
          .left-rotate {
            transform: rotate(-2deg);
          }
          .right-rotate {
            transform: rotate(2deg);
          }
          @media screen and (max-width: 374px) {
            font-size: 14px;
            h1 {
              font-size: 20px;
            }
            .photo {
              width: 214px;
              height: 140px;
            }
          }
        `}
      >
        <h1>{t('help')}</h1>
        <div className="photo left-rotate">
          <Photo
            srcSet={`
              /images/fortune/img_nookpoint_hint_01-2x.jpg 2x,
              /images/fortune/img_nookpoint_hint_01.jpg 1x
              `}
          />
        </div>
        <section className="sec-1">
          <p>{t('help_desc_01')}</p>
          <p>{t('help_desc_02')}</p>
          <p>{t('help_desc_03')}</p>
        </section>
        <div className="photo right-rotate">
          <Photo
            srcSet={`
              /images/fortune/img_nookpoint_hint_02-2x.jpg 2x,
              /images/fortune/img_nookpoint_hint_02.jpg 1x
              `}
          />
        </div>
        <section className="sec-2">
          <p>{t('help_desc_04')}</p>
        </section>
      </div>
    </Dialog>
  );
};
